import React, { Component } from 'react';
import { Col, Input, ListGroup, Row } from 'reactstrap';
import i18n from "../i18next";
import { deleteNotification, loadNotifications } from "../actions";
import { connect } from "react-redux";
import NotificationListItem from "./NotificationListItem";
import { localizeStatuses } from "../utils/CommonUtils";
import {
    AUTO_SYNC_FAILED, BILLING_CSV_FAIL, EMAIL_SENDING_FAIL,
    IMPORT_COMPLETED,
    IMPORT_FAILED,
    POS_OFFLINE,
    PUBLISH_COMPLETED, PUBLISH_FAILED,
    REJECTED_ORDER,
    RESTAURANT_PAUSED,
    SMS_SENDING_FAIL,
    URGENT_ORDER,
    UPDATE_POS_SETTINGS_FAIL,
    WIPE_MENU_FAIL,
    PRODUCT_REPORT,
    DOWNLOAD_ORDERS_REPORT,
    CENTRAL_SEARCH_ORDER_REPORT,
    WIPE_MENU
} from "../utils/Constants";

class Notifications extends Component {
    constructor(props) {
        super(props);

        this.changeState = this.changeState.bind(this);
        this.toggle = this.toggle.bind(this);

        this.state = {
            selectedNotificationFilter: '',
            notificationPopoverOpen: false
        };

    }

    changeState({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    toggle() {
        this.props.onToggle();
    }

    renderNotificationsFilter() {

        return (
            <Row>
                <Col sm={12}>
                    <Input type="select" name="selectedNotificationFilter" id="posStatus" placeholder={i18n.t('screens:mainContainer.notificationType')} value={this.state.selectedNotificationFilter} onChange={this.changeState}>
                        <option value="">{i18n.t('screens:mainContainer.chooseNotificationType')}</option>
                        <option value={RESTAURANT_PAUSED}>{localizeStatuses(RESTAURANT_PAUSED)}</option>
                        <option value={POS_OFFLINE}>{localizeStatuses(POS_OFFLINE)}</option>
                        <option value={REJECTED_ORDER}>{localizeStatuses(REJECTED_ORDER)}</option>
                        <option value={IMPORT_COMPLETED}>{localizeStatuses(IMPORT_COMPLETED)}</option>
                        <option value={PUBLISH_COMPLETED}>{localizeStatuses(PUBLISH_COMPLETED)}</option>
                        <option value={IMPORT_FAILED}>{localizeStatuses(IMPORT_FAILED)}</option>
                        <option value={PUBLISH_FAILED}>{localizeStatuses(PUBLISH_FAILED)}</option>
                        <option value={AUTO_SYNC_FAILED}>{localizeStatuses(AUTO_SYNC_FAILED)}</option>
                        <option value={EMAIL_SENDING_FAIL}>{localizeStatuses(EMAIL_SENDING_FAIL)}</option>
                        <option value={SMS_SENDING_FAIL}>{localizeStatuses(SMS_SENDING_FAIL)}</option>
                        <option value={BILLING_CSV_FAIL}>{localizeStatuses(BILLING_CSV_FAIL)}</option>
                        <option value={URGENT_ORDER}>{localizeStatuses(URGENT_ORDER)}</option>
                        <option value={UPDATE_POS_SETTINGS_FAIL}>{localizeStatuses(UPDATE_POS_SETTINGS_FAIL)}</option>
                        <option value={WIPE_MENU}>{localizeStatuses(WIPE_MENU)}</option>
                        <option value={WIPE_MENU_FAIL}>{localizeStatuses(WIPE_MENU_FAIL)}</option>
                        <option value={PRODUCT_REPORT}>{localizeStatuses(PRODUCT_REPORT)}</option>
                        <option value={DOWNLOAD_ORDERS_REPORT}>{localizeStatuses(DOWNLOAD_ORDERS_REPORT)}</option>
                        <option value={CENTRAL_SEARCH_ORDER_REPORT}>{localizeStatuses(CENTRAL_SEARCH_ORDER_REPORT)}</option>
                    </Input>
                </Col>
            </Row>
        )
    }

    renderNotifications() {

        return this.props.notifications.map((notification, i) => {

            let isNotificationHidden = (this.state.selectedNotificationFilter == '' || this.state.selectedNotificationFilter == notification.type) ? false : true;
            let isOrderDetails = (notification.type == 'REJECTED_ORDER') ? true : false;

            return (
                <NotificationListItem
                    isNotificationHidden={isNotificationHidden}
                    isOrderDetails={isOrderDetails}
                    notification={notification}
                    key={i}
                    toggle={this.props.onToggle}
                />


            )
        })
    }

    deleteNotification(notificationId) {
        this.props.deleteNotification(notificationId);
    }

    render() {
        const { notificationsHeaderContainer, notificationsTitle, notificationListGroup, notificationLastMsg } = styles;

        return (
            <div>
                <div style={notificationsHeaderContainer}>
                    <p style={notificationsTitle}>{i18n.t('screens:mainContainer.notifications')}</p>
                </div>
                {this.renderNotificationsFilter()}
                <br />
                <ListGroup style={notificationListGroup} flush>
                    {this.renderNotifications()}
                </ListGroup>
                <p style={notificationLastMsg}>{i18n.t('screens:mainContainer.notificationLastMsg')}</p>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        notifications: state.notifications
    };
};

export default connect(mapStateToProps, { loadNotifications, deleteNotification })(Notifications);

const styles = {
    notificationsHeaderContainer: {
        backgroundColor: '#f8f8f8'
    },
    notificationsTitle: {
        fontSize: 16,
        textAlign: 'center',
        paddingTop: 5,
        paddingBottom: 5
    },
    notificationListGroup: {
        maxHeight: 420,
        overflowY: 'auto'
    },
    notificationType: {
        marginBottom: 5,
        marginRight: 2
    },
    notificationListGroupItem: {
        padding: '5px 0px 0px 12px'
    },
    restaurantName: {
        fontSize: 12,
        color: 'grey',
        marginRight: 50,
        marginBottom: 2
    },
    dateStyle: {
        fontSize: 12,
        color: 'grey',
        marginRight: 2,
        marginBottom: 2
    },
    deleteNotification: {
        cursor: 'pointer',
        float: 'right'
    },
    orderDetailsLink: {
        color: '#0288d1',
        float: 'right',
        fontSize: 14
    },
    notificationLastMsg: {
        fontSize: 12,
        color: 'grey',
        margin: '6px 0px 0px 0px'
    }
}


// WEBPACK FOOTER //
// ./src/components/Notifications.js